import { render } from "./top-bar.vue?vue&type=template&id=699b1e48&ts=true"
import script from "./top-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./top-bar.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shell/top-bar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "699b1e48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('699b1e48', __exports__)) {
    api.reload('699b1e48', __exports__)
  }
  
  module.hot.accept("./top-bar.vue?vue&type=template&id=699b1e48&ts=true", () => {
    api.rerender('699b1e48', render)
  })

}


export default __exports__